<template>
    <div
        :class="[lClass,'card-container' ,'card-container-' + type,'card-container-' + type + '-' + position, full?'card-container-full':'card-container-unfull']"
    >
        <template v-if="type ==='primary' || type ==='cover'">
            <img
                v-if="!plaintext"
                :class="[lImgClass,full?'cover-img-full':'cover-img-unfull', 'card-img-' + type , 'card-img-' + type + '-' + position]"
                :src="image"
            />
            <div class="card-content">
                <span :class="[lTitleClass, 'card-title', 'card-title-' + type]">{{title}}</span>
                <slot />
            </div>
        </template>
        <template v-if="type ==='avatar'">
            <div class="card-avatar-top">
                <div class="card-avatar-left">
                    <img :class="[lImgClass, 'card-img-' + type]" :src="image" />
                    <div class="card-avatar">
                        <span :class="[lTitleClass, 'card-title','card-title-' + type]">{{title}}</span>
                        <span class="describe">{{describe}}</span>
                    </div>
                </div>
                <slot name="more" />
            </div>
            <slot />
        </template>
    </div>
</template>

<script>
export default {
    name: 'Card',
    components: {},
    props: {
        image: String,
        title: String,
        describe: String,
        plaintext: Boolean,
        full: Boolean,
        position: {
            type: String,
            default: 'left'
        },
        type: {
            type: String,
            default: 'primary'
        },
        lClass: {
            type: String,
            default: ''
        },
        lImgClass: {
            type: String,
            default: ''
        },
        lTitleClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    }
}
</script>
<style lang='stylus'>
.card-container
    margin: 0 auto
    padding: 15px
    box-sizing: border-box
    background: #fff
    display: flex
    align-items: flex-start
    &-full
        width: 375px
    &-unfull
        width: 345px
        box-shadow: 0 2px 10px 0 rgba(212, 217, 223, 0.5)
        border-radius: 4px
    &-primary-left
        flex-direction: row
    &-primary-right
        flex-direction: row-reverse
    &-avatar
        flex-direction: column
    &-cover
        flex-direction: column
.cover-img
    &-full
        width: 345px
        // height: 260rpx
    &-unfull
        width: 315px
        // height: 260rpx;
.card-img
    &-primary
        width: 120px
        // height: 120px
        // overflow: hidden
        &-left
            margin-right: 20px
        &-right
            margin-left: 20px
    &-avatar
        height: 30px
        width: 30px
        border-radius: 50%
        margin-right: 15px
.card-img-avatar
    height: 30px
    width: 30px
    border-radius: 50%
    margin-right: 15px
.card-content
    position: relative
    display: flex
    flex-direction: column
    flex: 1
    width: 100%
.card-title
    overflow: hidden
    text-overflow: ellipsis
    color: #333
    &-primary
        font-size: 16px
        display: -webkit-box
        -webkit-box-orient: vertical
        -webkit-line-clamp: 2
    &-avatar
        font-size: 14px
    &-cover
        font-size: 15px
        margin-top: 5px
.card-title-avatar
    font-size: 14px
.card-avatar-top
    display: flex
    flex-direction: row
    height: 50px
    align-items: center
    justify-content: space-between
.card-avatar-left
    display: flex
    flex-direction: row
    align-items: center
.card-avatar
    display: flex
    flex-direction: column
.describe
    color: #666
    font-size: 12px
</style>
